/*
 * PremierStreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premierstreets
 * Author premierstreets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { CartSandbox } from '../../../../../../core/cart/cart.sandbox';
import { ProductControlSandbox } from '../../../../../../core/product-control/product-control.sandbox';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { ListsSandbox } from '../../../../../../core/lists/lists.sandbox';
import { ConfigService } from '../../../../../../core/service/config.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatSnackBar } from '@angular/material/snack-bar';

import * as _ from 'lodash';
import { take } from 'rxjs/operators';
import { CommonService } from '../../../../../../core/common/common.service';
import { CommonSandbox } from '../../../../../../core/common/common.sandbox';


@Component({
	selector: 'app-cart-popup',
	templateUrl: 'cart-popup.component.html',
	styleUrls: ['cart-popup.component.scss'],
	animations: [
		trigger('fadeInAnimation', [

			// route 'enter' transition
			transition(':enter', [

				// css styles at start of transition
				style({ opacity: 0 }),

				// animation and styles at end of transition
				animate('.3s', style({ opacity: 1 }))
			]),
		]),
	],
	host: { '[@fadeInAnimation]': '' }

})


export class CartPopupComponent implements OnInit, OnDestroy {

	public subscriptions: Array<Subscription> = [];
	public currency: any = {};
	public submitted = false;
	public menuState = 'in';
	public currentUser = JSON.parse(localStorage.getItem('storeUser'));
	public imagePath: string;

	// tire price
	public tirePriceArray: any = [];
	public tirePrice: any;
	public quantity = 0;
	public opened = false;
	public maxQtyCheck = 0;
	public products: any;
	public freeProduct = false;
	public product: any;
	public promocode: any;
	public inviteCustomer: any;
	public isProductAdded: boolean = false;


	constructor(
		public cartSandbox: CartSandbox,
		public productControlSandbox: ProductControlSandbox,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public router: Router,
		public commonService: CommonService,
		@Inject(PLATFORM_ID) private platformId: Object,
		public listSandbox: ListsSandbox,
		public configService: ConfigService,
		public snackBar: MatSnackBar,
		public commonSandbox: CommonSandbox,
		private dialogRef: MatDialogRef<CartPopupComponent>) {
	}

	onClickedOutside(e: Event) {
		// if (this.opened) {
		// 	this.dialogRef.close();
		// }

	}

	ngOnInit() {
		this.dialogRef.afterOpened().subscribe(() => {
			this.opened = true;
		});
		if (isPlatformBrowser(this.platformId)) {
			this.currentUser = JSON.parse(localStorage.getItem('storeUser'));
		}

		this.commonService.getSiteSetting().toPromise().then((response: any) => {
			this.maxQtyCheck = response.data.maxQuantity;
			this.commonSandbox.setSiteSettings(response.data);
		})
		this.currency = JSON.parse(localStorage.getItem('currency'));
		this.imagePath = this.configService.getImageUrl();

		if (this.currentUser) {
			this.commonService.getInviteFreeProduct().toPromise().then(res => {
				console.log(res.data);
				if (res.data) {
					if (res.data.product) {
						this.product = res.data.product;
					}
					if (res.data.promocode) {
						this.promocode = res.data.promocode;
					}
					if (res.data.inviteCustomer) {
						this.inviteCustomer = res.data.inviteCustomer;

						if ((this.currentUser.email === this.inviteCustomer.invitedEmail) && this.inviteCustomer.isFreeProduct && this.inviteCustomer.isFreeProductClaim) {
							
							this.isProductAdded = true;
						} else if((this.currentUser.email !== this.inviteCustomer.invitedEmail) && this.inviteCustomer.isFreeProductClaimBySender){
							this.isProductAdded = true;
						}
					}
				} else {
					this.isProductAdded = true;
				}

				this.productControlSandbox.cartlist$.subscribe(data => {
					if (data) {
	
						for (let product of data) {
							if (this.product) {
								if (product.productId == this.product.productId) {
									this.isProductAdded = true;
									product.price = 0;
								}
							}
						}
						this.productControlSandbox.setItems(data);
					}
				});
			});

			this.productControlSandbox.cartlist$.subscribe(data => {
				if (data) {
					console.log(data, 'data');
					for (let product of data) {
						if (this.product) {
							if (product.productId == this.product.productId) {
								this.isProductAdded = true;
								product.price = 0;
							}
						}
					}
					this.productControlSandbox.setItems(data);
				}
			});

		} else {

			this.isProductAdded = true;
			this.commonService.getSiteSetting().toPromise().then((response: any) => {
				this.maxQtyCheck = response.data.maxQuantity;
				this.commonSandbox.setSiteSettings(response.data);
			})
			this.currency = JSON.parse(localStorage.getItem('currency'));
			this.imagePath = this.configService.getImageUrl();
			this.productControlSandbox.cartlist$.subscribe(data => {
				if (data) {
					console.log(data, 'data');
					for (let product of data) {
						if (this.product) {
							if (product.productId == this.product.productId) {
								this.isProductAdded = true;
								product.price = 0;
							}
						}
					}
					this.productControlSandbox.setItems(data);
				}
			});
		}


		this.dialogRef.afterClosed().subscribe(() => {
			this.opened = false;
		})


	}
	claim() {
		const checkoutToken = '1';
		this.router.navigate(['/checkout'], {
			queryParams:
			{
				promocode: this.promocode.promotionalCode
			}
		});
		this.dialogRef.close();
		if (isPlatformBrowser(this.platformId)) {
			localStorage.setItem('checkout', checkoutToken);
		}
	}
	addFreeProduct() {
		// if (this.product && this.product.hasStock && this.product.hasStock !=0) {
		this.addToCartMethod(this.product);
		this.isProductAdded = true;

		// } else {
		// 	this.snackBar.open('Sorry, Free product is out of stock', '×', {
		// 		panelClass: 'error',
		// 		verticalPosition: 'top',
		// 		horizontalPosition: 'right',
		// 		duration: 3000
		// 	});
		// }
	}

	addToCartMethod(details) {
		const product = JSON.parse(JSON.stringify(details));

		product.tirePrice = '';
		product.minTireQty = 0;

		if (this.currentUser) {

			const params: any = {};
			params.productId = product.productId;
			params.quantity = this.quantity > 0 ? this.quantity : 1;
			params.productPrice = "0";
			params.tirePrice = this.tirePrice;
			params.varientName = product.variantName;
			params.productVarientOptionId = product.variantId;
			params.selectedImage = product.selectedImage;
			params.skuName = product.sku;

			params.type = 'new';

			params.productOptionValueId = [];


			this.cartSandbox.doAddToCart(params);
		}
		if (product.optionRequired === 1) {
			const params: any = {};
			params.id = product.productId;
			this.listSandbox.getProductDetailsMandatory(params);
		} else {
			this.products = product;
			const param: any = {};
			param.totalOptions = 0;
			product.productCount = this.quantity > 0 ? this.quantity : 1;

			product.skuName = product.skuName || product.sku;

			product._optionValueArray = [];
			param._optionValueArray = [];
			product.price = 0;
			product.productPrice = 0;

			product.selectedOptions = [];

			this.productControlSandbox.selectedOptions(param);
			product._totalOptions = param.totalOptions;
			this.productControlSandbox.addItemsToCart(product, param);

		}
	}

	// remove product from cart
	remove(product) {
		console.log(" *** product removed **** ", product);
		if (this.product) {
			if (product.productId == this.product.productId) {
				this.isProductAdded = false;
			}
		}
		if (this.currentUser) {
			const params: any = {};
			params.productId = product.productId;
			params.productPrice = product.price;
			params.varientName = product.variantName;
			params.productVarientOptionId = product.variantId;
			params.selectedImage = product.selectedImage;
			params.skuName = product.skuName;
			params.quantity = 0;
			if (product.productOption && product.productOption.length > 0) {
				params.optionName = '';
				params.optionValueName = '';
			}
			params.productOptionValueId = product.selectedOptions;
			params.type = 'new';
			this.cartSandbox.doAddToCart(params);
		}
		this.productControlSandbox.removeItemFromCart(product);

	}

	public checkoutPage() {
		const checkoutToken = '1';
		this.router.navigate(['/checkout'], {});
		this.dialogRef.close();
		if (isPlatformBrowser(this.platformId)) {
			localStorage.setItem('checkout', checkoutToken);
		}
	}

	public viewCart() {
		this.router.navigate(['/cart']);
		this.dialogRef.close();
	}

	calculatePrice(option: number, price: number, taxType: number, taxValue: number) {
		switch (taxType) {
			case 1:
				const priceWithOutTax = ((+price) + (+option)) + Number(taxValue);
				return _.round(priceWithOutTax, 2);
			case 2:
				const percentToAmount = ((+price) + (+option)) * (Number(taxValue) / 100);
				const priceWithTax = ((+price) + (+option)) + percentToAmount;
				return _.round(priceWithTax, 2);
			default:
				return _.round(((+price) + (+option)), 2);
		}
	}

	// increase or decrease product count(tire price)
	changeCount(product, operation) {
		if (this.product) {
			if (product.productId == this.product.productId && operation) {
				this.snackBar.open('You can not add more of this item', '×', {
					panelClass: 'error',
					verticalPosition: 'top',
					horizontalPosition: 'right',
					duration: 3000
				});
				return;
			}
			if (product.productId == this.product.productId && !operation) {
				this.isProductAdded = false;
			}
		}
		if (product.hasTirePrice === 1) {
			product.productTirePrices.forEach(data => {
				this.tirePriceArray.push(data.quantity);
			});
		}

		if (product.hasStock === 1) {
			const params: any = {};
			params.productId = product.productId;
			params.productPrice = product.price;
			if (operation) {
				const quantity = product.productCount + 1;
				if ((product.quantity <= quantity) && (this.maxQtyCheck == 1)) {
					this.snackBar.open('You have reached the maximum quantity limit', '×', {
						panelClass: 'error',
						verticalPosition: 'top',
						horizontalPosition: 'right',
						duration: 3000
					});
				} else {
					this.quantity = Number(product.productCount) + 1;
					this.addToCart(product, operation);
				}
			}
			if (!operation) {
				this.quantity = Number(product.productCount) - 1;
				this.addToCart(product, operation);
			}

		} else {
			if (operation) {
				const quantity = product.productCount + 1;
				if ((product.quantity < quantity) && (this.maxQtyCheck == 1)) {
					this.snackBar.open('You have reached the maximum quantity limit', '×', {
						panelClass: 'error',
						verticalPosition: 'top',
						horizontalPosition: 'right',
						duration: 3000
					});
					return;
				} else {
					this.quantity = product.productCount + 1;
					this.addToCart(product, operation);
				}
			} else {
				this.quantity = product.productCount - 1;
				this.addToCart(product, operation);
			}
		}
		if (operation) {
			if (this.currentUser) {
				this.subscriptions.push(this.cartSandbox.addToCartLoaded$.pipe(take(2)).subscribe((success) => {
					console.log(" **** product success ****  ", product, success);
					if (success) {
						this.productControlSandbox.ChangeCount(product, operation);
					}
				}));
			} else {
				this.productControlSandbox.ChangeCount(product, operation);
			}
		} else {
			this.productControlSandbox.ChangeCount(product, operation);
		}
	}

	addToCart(product, operation) {
		this.itemAddInCart(product, operation);
	}

	itemAddInCart(product, operation) {
		if (this.currentUser) {
			console.log(product, 'product');
			const params: any = {};
			params.productId = product.productId;
			params.productPrice = product.price;
			params.tirePrice = this.tirePrice || 0;
			params.varientName = product.variantName || null;
			params.productVarientOptionId = product.variantId || 0;
			params.selectedImage = product.selectedImage || null;
			params.skuName = product.skuName || product.sku || null;
			if (operation) {
				if (product.productCount) {
					params.quantity = Number(product.productCount) + 1;
				} else {
					params.quantity = 1;
				}

			}
			if (!operation) {
				if (product.productCount) {
					params.quantity = Number(product.productCount) - 1;
				} else {
					params.quantity = 1;
				}
			}
			if (product.productOption && product.productOption.length > 0) {
				const tempParams: any = {};
				tempParams.totalOptions = product._totalOptions;
				tempParams.options = product.productOption;
				tempParams.optionValueArray = product._optionValueArray;
				params.optionName = JSON.stringify(tempParams);
				params.optionValueName = '';
			}
			params.productOptionValueId = product.selectedOptions || [];
			console.log(params, 'product params');
			this.cartSandbox.doAddToCart(params);
		}
	}

	close() {
		this.dialogRef.close();
	}


	ngOnDestroy() {
		this.subscriptions.forEach(each => each.unsubscribe());
	}

}
